import GeneralTranslations from "../../../Common/ModuleTranslations/fr";

export default {
  locale: "fr",
  name: "Affichage",
  translation: { displayName: "Traductions" },
  fields: {
    list: [
      ...GeneralTranslations.fields.list,
      {
        fieldName: "active",
        displayName: "est Actif",
      },
      {
        fieldName: "conditions",
        displayName: "Conditions",
      },
      {
        fieldName: "position",
        displayName: "Ordre",
      },
    ],
    form: [
      ...GeneralTranslations.fields.form,
      {
        fieldName: "active",
        displayName: "Actif",
        helpText: "L'affichage est-il visible sur le moteur de réservation ?",
      },
      {
        fieldName: "defaultOption",
        displayName: "S'ouvre par défaut",
      },
      {
        fieldName: "startDate",
        displayName: "Date de début de la fenêtre de réservation",
        placeholder: "Entrez une date",
      },
      {
        fieldName: "endDate",
        displayName: "Date de fin de la fenêtre de réservation",
        placeholder: "Entrez une date",
      },
      {
        fieldName: "entityFilter",
        displayName: "Afficher uniquement pour :",
        optionDisplay: {
          PROPERTY: {
            label: "Propriété",
          },
          ACCOMMODATION: {
            label: "Hébergement",
          },
        },
        helpText: "Ne sera visible que pour les éléments de ce type",
      },
      {
        fieldName: "tickerFilter",
        displayName:
          "Afficher uniquement pour les identifiants suivants (séparés par des virgules) :",
      },
      {
        fieldName: "label",
        displayName: "Nom du tag",
      },
      {
        fieldName: "youTubeURL",
        displayName: "URL Youtube",
      },
      {
        fieldName: "contentType",
        displayName: "Type de contenu",
        optionDisplay: {
          HTML: {
            label: "HTML",
          },
          VIDEO: {
            label: "Vidéo",
          },
          IMAGE: {
            label: "Image",
          },
        },
      },
      {
        fieldName: "content",
        displayName: "Contenu",
      },
    ],
  },
};
